import { useEffect } from 'react'

const SuccessModal = ({ isOpen, onClose, title, message, autoClose = true, autoCloseDelay = 3000 }) => {
  useEffect(() => {
    if (isOpen && autoClose) {
      const timer = setTimeout(() => {
        onClose()
      }, autoCloseDelay)
      
      return () => clearTimeout(timer)
    }
  }, [isOpen, autoClose, autoCloseDelay, onClose])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 animate-fadeIn">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full transform animate-scaleIn">
        {/* Header avec icône de succès */}
        <div className="p-6 text-center">
          <div className="mx-auto w-16 h-16 rounded-full flex items-center justify-center mb-4 animate-bounce" style={{ backgroundColor: '#D4AF37' }}>
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-8 w-8 text-white" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={3} 
                d="M5 13l4 4L19 7" 
              />
            </svg>
          </div>
          
          <h3 className="text-2xl font-bold mb-2" style={{ color: '#001F3F' }}>
            {title || 'Succès !'}
          </h3>
          
          <p className="text-gray-600 mb-6">
            {message || 'Votre annonce a été publiée avec succès !'}
          </p>
          
          <button
            onClick={onClose}
            className="px-8 py-3 rounded-lg font-semibold text-white transition-all hover:opacity-90 hover:scale-105"
            style={{ backgroundColor: '#D4AF37' }}
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  )
}

export default SuccessModal
